import { render, staticRenderFns } from "./Aktuell.vue?vue&type=template&id=b04ad794&scoped=true&"
import script from "./Aktuell.vue?vue&type=script&lang=js&"
export * from "./Aktuell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04ad794",
  null
  
)

export default component.exports